
import { Vue } from "vue-property-decorator";
export default class ErrorPageComponent extends Vue {
  goToHome() {
    this.$router.push({ name: "login" });
  }
}
